import type { IconData } from '@stacksjs/iconify-core'

export const healthMedicines: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m12.53 11.47l1.813-1.813a5.657 5.657 0 1 0-8-8L4.53 3.47zm-1.06 1.06l-8-8l-1.813 1.813a5.657 5.657 0 1 0 8 8z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default healthMedicines
